import React, { FC } from 'react';
import { Controller } from 'react-hook-form';
import { omit } from 'lodash';
import { ComboBox, FormControl } from '@fiverr-private/orca';
import { translate as t } from '@fiverr-private/i18n-react';
import { employmentTypeEnumToTranslationKey, T_FORM_KEY, T_KEY } from '../../utils';
import { EmploymentType } from '../../../../gql-operations/gql-generated';
import { FieldComponentProps } from '../../shared/types';

import { comboBoxStyle } from '../../shared/styles.ve.css';

const EmploymentTypeField: FC<FieldComponentProps> = ({ control }) => (
    <FormControl label={t(`${T_FORM_KEY}.fields.employment_type.label`)} isOptional>
        <Controller
            name="employmentType"
            control={control}
            render={({ field: { onChange, value: employmentType, name } }) => (
                <ComboBox
                    menuShouldBlockScroll
                    id={name}
                    className={comboBoxStyle}
                    placeholder={t(`${T_FORM_KEY}.fields.employment_type.placeholder`)}
                    isMulti={false}
                    options={Object.keys(omit(employmentTypeEnumToTranslationKey, EmploymentType.Unspecified)).map(
                        (employmentType) => ({
                            label: t(`${T_KEY}.employment_type.${employmentTypeEnumToTranslationKey[employmentType]}`),
                            value: employmentType,
                        })
                    )}
                    onChange={({ value }) => onChange(value)}
                    value={
                        employmentType && {
                            label: t(`${T_KEY}.employment_type.${employmentTypeEnumToTranslationKey[employmentType]}`),
                            value: employmentType,
                        }
                    }
                />
            )}
        />
    </FormControl>
);

export default EmploymentTypeField;
